import React, { Suspense, lazy } from 'react';
import { useParams } from 'react-router-dom';

import './ApiDefinition.css';
import Servers from './plugins/Servers';

const SwaggerUI = lazy(() => import('swagger-ui-react'));

const ApiDefinition = () => {
  const { name, namespace, version = 'latest' } = useParams();
  const url = `/definitions/${namespace}/${name}/${version}.json`;

  return (
    <div className="SwaggerUI">
      <Suspense fallback={<div>Loading...</div>}>
        <SwaggerUI
          url={url}
          docExpansion="list"
          plugins={[Servers]}
          requestInterceptor={req => {
            if (!req.url.startsWith(window.location.origin)) {
              req.credentials = 'include';
              req.mode = 'cors';
            }
            return req;
          }}
        />
      </Suspense>
    </div>
  );
};

export default ApiDefinition;
